import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { Router } from '@angular/router';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { ThemeService } from 'src/app/theme.service';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent implements OnInit, OnDestroy {
  public currencies = ['USD', 'EUR'];
  public currency: any;
  public flags = [
    { name: 'English', image: 'assets/images/flags/gb.svg' },
    { name: 'German', image: 'assets/images/flags/de.svg' },
    { name: 'French', image: 'assets/images/flags/fr.svg' },
    { name: 'Russian', image: 'assets/images/flags/ru.svg' },
    { name: 'Turkish', image: 'assets/images/flags/tr.svg' }
  ]
  public flag: any;
  store_id: any;
  notification_count: any;
  constructor(public appService: AppService, protected localStorage: LocalStorage,
    private angularFireMessaging: AngularFireMessaging,private themeService: ThemeService) {
    // this.getAllNotifications();
  }
  ngOnInit() {
    this.currency = this.currencies[0];
    this.flag = this.flags[0];

    this.themeService.initializeTheme();

    const isDarkTheme = this.themeService.isDarkModeEnabled;
    const themeIcon = document.getElementById('theme-icon') as HTMLElement;
    const themeSwitch = document.getElementById('theme-switch') as HTMLInputElement;
  
    if (isDarkTheme) {
      themeIcon.classList.replace('fa-moon-o', 'fa-sun-o');
      document.body.classList.add('dark-mode'); // Add a class to body for dark mode styles
      themeSwitch.checked = true;
    } else {
      themeIcon.classList.replace('fa-sun-o', 'fa-moon-o');
      document.body.classList.remove('dark-mode'); // Remove the class when not in dark mode
      themeSwitch.checked = false;
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('dark-mode-body');
    document.querySelectorAll('.header').forEach(header => header.classList.remove('dark-mode-header'));
    document.querySelectorAll('.sidenav').forEach(sideMenu => sideMenu.classList.remove('dark-mode-side-menu'));
    document.querySelectorAll('.page-title').forEach(pageTitle => pageTitle.classList.remove('dark-mode-page-title'));
    document.querySelectorAll('.menu-title').forEach(menuTitle => menuTitle.classList.remove('dark-mode-menu-title'));
  }

  public changeCurrency(currency) {
    this.currency = currency;
  }
  public changeLang(flag) {
    this.flag = flag;
  }
  signout() {
    this.appService.signOut();
  }
  toggleBackground(event: any) {
    const isChecked = event.target.checked;
    this.themeService.toggleDarkMode(isChecked);
  
    const themeIcon = document.getElementById('theme-icon');
  
    if (isChecked) {
      themeIcon.classList.replace('fa-moon-o', 'fa-sun-o'); 
    } else {
      themeIcon.classList.replace('fa-sun-o', 'fa-moon-o');
    }
  }  
  
  
}
